export const CustomPalettes = {
  'Color/Token/Text/Primary': '#FAFAFA',
  'Color/Token/Text/Secondary': '#7B7B7B',
  'Color/Token/Text/Disabled': '#C4C4C4',
  // Primary
  'Space/pallet/Primary/50': '#F5FAF9',
  'Space/pallet/Primary/100': '#C4F2EE',
  'Space/pallet/Primary/200': '#94F2EA',
  'Space/pallet/Primary/300': '#7AF0E6',
  'Space/pallet/Primary/400': '#5DE3D8',
  'Space/pallet/Primary/500-primary': '#3EC9BE',
  'Space/pallet/Primary/600-hover': '#2FB5AA',
  'Space/pallet/Primary/700-press': '#219E94',
  'Space/pallet/Primary/800': '#137A72',
  'Space/pallet/Primary/900': '#0A5C55',
  // Accent
  'Space/pallet/Accent/50': '#FFFBE5',
  'Space/pallet/Accent/100': '#FFF3B2',
  'Space/pallet/Accent/200': '#FFEB80',
  'Space/pallet/Accent/300': '#FFE766',
  'Space/pallet/Accent/400': '#FFDE33',
  'Space/pallet/Accent/500-primary': '#FFD600',
  'Space/pallet/Accent/600-hover': '#F0C900',
  'Space/pallet/Accent/700-press': '#E5C100',
  'Space/pallet/Accent/800': '#D9B600',
  'Space/pallet/Accent/900': '#CCAB00',
  // Gray
  'Space/pallet/Gray/50-background': '#FAFAFA',
  'Space/pallet/Gray/100-divider': '#E9E9E9',
  'Space/pallet/Gray/200': '#D9D9D9',
  'Space/pallet/Gray/300-disablle': '#C4C4C4',
  'Space/pallet/Gray/400': '#9E9E9E',
  'Space/pallet/Gray/500': '#7B7B7B',
  'Space/pallet/Gray/600-secondary': '#595960',
  'Space/pallet/Gray/700': '#434343',
  'Space/pallet/Gray/800-primary': '#13131D',
  'Space/pallet/Gray/900': '#000000',
  'Space/pallet/Gray/0': '#FFFFFF',
  // Green
  'Space/pallet/Green/50-background': '#EFFBE6',
  'Space/pallet/Green/100': '#D7F6C2',
  'Space/pallet/Green/200': '#BBEF99',
  'Space/pallet/Green/300': '#9CE86C',
  'Space/pallet/Green/400': '#82E244',
  'Space/pallet/Green/500': '#67DC02',
  'Space/pallet/Green/600-primary': '#56CB02',
  'Space/pallet/Green/700-hover': '#36B700',
  'Space/pallet/Green/800-press': '#05A101',
  'Space/pallet/Green/900': '#027F00',
  // Red
  'Space/pallet/Red/50-background': '#FCE9E5',
  'Space/pallet/Red/100': '#FFCDB8',
  'Space/pallet/Red/200': '#FFAC8A',
  'Space/pallet/Red/300': '#FF8C5A',
  'Space/pallet/Red/400': '#FF7334',
  'Space/pallet/Red/500-primary': '#FF5C00',
  'Space/pallet/Red/600-hover': '#F45501',
  'Space/pallet/Red/700-press': '#E64E01',
  'Space/pallet/Red/800': '#D84600',
  'Space/pallet/Red/900': '#C13800',
  // Blue
  'Space/pallet/Blue/50-background': '#EAF4FF',
  'Space/pallet/Blue/100': '#BDDCFF',
  'Space/pallet/Blue/200': '#8FC4FF',
  'Space/pallet/Blue/300': '#61ACFF',
  'Space/pallet/Blue/400': '#3394FF',
  'Space/pallet/Blue/500': '#207BDD',
  'Space/pallet/Blue/600-primary': '#1163BB',
  'Space/pallet/Blue/700-hover': '#064C99',
  'Space/pallet/Blue/800-press': '#003977',
  'Space/pallet/Blue/900': '#002955',
  // Yellow
  'Space/pallet/Yellow/50-background': '#FFF8E1',
  'Space/pallet/Yellow/100': '#FFECB2',
  'Space/pallet/Yellow/200': '#FFE082',
  'Space/pallet/Yellow/300': '#FFD44F',
  'Space/pallet/Yellow/400': '#FFCA27',
  'Space/pallet/Yellow/500': '#FFC109',
  'Space/pallet/Yellow/600-primary': '#FFB300',
  'Space/pallet/Yellow/700-hover': '#FFA000',
  'Space/pallet/Yellow/800-press': '#FF8E00',
  'Space/pallet/Yellow/900': '#FF6E00',
} as const;
